'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = require('redux-saga/effects');

var _objectives = require('../actions/objectives');

var _api = require('../api');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchObjectives),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchObjectivesRequest);

function fetchObjectives() {
    var response, objectives;
    return regeneratorRuntime.wrap(function fetchObjectives$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/objectives');

                case 3:
                    response = _context.sent;
                    objectives = response.data.sort(function (a, b) {

                        if (a.name < b.name) {
                            return -1;
                        }
                        return 1;
                    });
                    _context.next = 7;
                    return (0, _effects.put)(_objectives.actionCreators.fetchObjectivesSucceeded(objectives));

                case 7:
                    _context.next = 13;
                    break;

                case 9:
                    _context.prev = 9;
                    _context.t0 = _context['catch'](0);
                    _context.next = 13;
                    return (0, _effects.put)(_objectives.actionCreators.fetchObjectivesFailed(_context.t0));

                case 13:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 9]]);
}

function fetchObjectivesRequest() {
    return regeneratorRuntime.wrap(function fetchObjectivesRequest$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeLatest)(_objectives.actionTypes.FETCH_OBJECTIVES_REQUEST, fetchObjectives);

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this);
}

exports.default = [fetchObjectivesRequest];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvZWZmZWN0cy9vYmplY3RpdmVzLmpzIl0sIm5hbWVzIjpbImZldGNoT2JqZWN0aXZlcyIsImZldGNoT2JqZWN0aXZlc1JlcXVlc3QiLCJyZXF1ZXN0IiwicmVzcG9uc2UiLCJvYmplY3RpdmVzIiwiZGF0YSIsInNvcnQiLCJhIiwiYiIsIm5hbWUiLCJhY3Rpb25DcmVhdG9ycyIsImZldGNoT2JqZWN0aXZlc1N1Y2NlZWRlZCIsImZldGNoT2JqZWN0aXZlc0ZhaWxlZCIsImFjdGlvblR5cGVzIiwiRkVUQ0hfT0JKRUNUSVZFU19SRVFVRVNUIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQTs7QUFDQTs7QUFDQTs7bURBRVVBLGU7b0RBbUJBQyxzQjs7QUFuQlYsU0FBVUQsZUFBVjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsMkJBRytCLG1CQUFLRSxZQUFMLEVBQWMsS0FBZCxFQUFxQixhQUFyQixDQUgvQjs7QUFBQTtBQUdjQyw0QkFIZDtBQUtjQyw4QkFMZCxHQUsyQkQsU0FBU0UsSUFBVCxDQUFjQyxJQUFkLENBQW1CLFVBQUNDLENBQUQsRUFBSUMsQ0FBSixFQUFVOztBQUU1Qyw0QkFBSUQsRUFBRUUsSUFBRixHQUFTRCxFQUFFQyxJQUFmLEVBQXFCO0FBQ2pCLG1DQUFPLENBQUMsQ0FBUjtBQUNIO0FBQ0QsK0JBQU8sQ0FBUDtBQUNILHFCQU5rQixDQUwzQjtBQUFBO0FBQUEsMkJBYWMsa0JBQUlDLDJCQUFlQyx3QkFBZixDQUF3Q1AsVUFBeEMsQ0FBSixDQWJkOztBQUFBO0FBQUE7QUFBQTs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLDJCQWVjLGtCQUFJTSwyQkFBZUUscUJBQWYsYUFBSixDQWZkOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOztBQW1CQSxTQUFVWCxzQkFBVjtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSwyQkFDVSx5QkFBV1ksd0JBQVlDLHdCQUF2QixFQUFpRGQsZUFBakQsQ0FEVjs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7a0JBSWUsQ0FDWEMsc0JBRFcsQyIsImZpbGUiOiJvYmplY3RpdmVzLmpzIiwic291cmNlUm9vdCI6Ii9zcmMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjYWxsLCBwdXQsIHRha2VMYXRlc3QgfSBmcm9tICdyZWR1eC1zYWdhL2VmZmVjdHMnO1xuaW1wb3J0IHsgYWN0aW9uVHlwZXMsIGFjdGlvbkNyZWF0b3JzIH0gZnJvbSAnLi4vYWN0aW9ucy9vYmplY3RpdmVzJztcbmltcG9ydCB7IHJlcXVlc3QgfSBmcm9tICcuLi9hcGknO1xuXG5mdW5jdGlvbiogZmV0Y2hPYmplY3RpdmVzKCkge1xuXG4gICAgdHJ5IHtcbiAgICAgICAgY29uc3QgcmVzcG9uc2UgPSB5aWVsZCBjYWxsKHJlcXVlc3QsICdnZXQnLCAnL29iamVjdGl2ZXMnKTtcblxuICAgICAgICBjb25zdCBvYmplY3RpdmVzID0gcmVzcG9uc2UuZGF0YS5zb3J0KChhLCBiKSA9PiB7XG5cbiAgICAgICAgICAgIGlmIChhLm5hbWUgPCBiLm5hbWUpIHtcbiAgICAgICAgICAgICAgICByZXR1cm4gLTE7XG4gICAgICAgICAgICB9XG4gICAgICAgICAgICByZXR1cm4gMTtcbiAgICAgICAgfSk7XG5cbiAgICAgICAgeWllbGQgcHV0KGFjdGlvbkNyZWF0b3JzLmZldGNoT2JqZWN0aXZlc1N1Y2NlZWRlZChvYmplY3RpdmVzKSk7XG4gICAgfSBjYXRjaCAoZXJyb3IpIHtcbiAgICAgICAgeWllbGQgcHV0KGFjdGlvbkNyZWF0b3JzLmZldGNoT2JqZWN0aXZlc0ZhaWxlZChlcnJvcikpO1xuICAgIH1cbn1cblxuZnVuY3Rpb24qIGZldGNoT2JqZWN0aXZlc1JlcXVlc3QoKSB7XG4gICAgeWllbGQgdGFrZUxhdGVzdChhY3Rpb25UeXBlcy5GRVRDSF9PQkpFQ1RJVkVTX1JFUVVFU1QsIGZldGNoT2JqZWN0aXZlcyk7XG59XG5cbmV4cG9ydCBkZWZhdWx0IFtcbiAgICBmZXRjaE9iamVjdGl2ZXNSZXF1ZXN0LFxuXTsiXX0=


//////////////////
// WEBPACK FOOTER
// ./src/client/effects/objectives.js
// module id = 2227
// module chunks = 0